import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Identifique',
    desc: 'Use nuestra auditoría simple para ver qué cuentas son vitales.'
  }, {
    num: '2',
    title: 'Ancle',
    desc: 'Cree su Carpeta de Emergencia física siguiendo nuestras plantillas claras.'
  }, {
    num: '3',
    title: 'Entregue',
    desc: 'Siga el protocolo para informar a su heredero digital dónde está la llave.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-53">
          Cómo funciona en 3 simples pasos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-54">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gold/30 z-0" data-id="element-55"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-56">
              <div className="w-24 h-24 rounded-full bg-white border-4 border-gold flex items-center justify-center shadow-warm mb-6" data-id="element-57">
                <span className="font-heading text-4xl font-bold text-burgundy" data-id="element-58">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-burgundy mb-4" data-id="element-59">
                {step.title}
              </h3>
              <p className="text-lg text-charcoal-light px-4" data-id="element-60">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}